import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openLink(event) {
    // Don't open if clicking on a link or button
    if (event.target.closest('a, button')) {
      return
    }

    const url = this.element.dataset.url
    if (url) {
      window.open(url, '_blank')
    }
  }
}
